// Helpers for the integration-metadata contract an action declares via its
// metadata_schema. Declared properties are pre-seeded (their `default`, else
// '') into the integration metadata editor, mirroring the backend seed.

export function declaredMetadataProperties(metadataSchema) {
  const properties = metadataSchema?.properties;
  if (!properties || typeof properties !== 'object') return [];

  return Object.entries(properties).map(([key, spec]) => ({
    key,
    description: spec?.description || '',
    defaultValue: spec && spec.default !== undefined ? spec.default : '',
  }));
}

// rowId keys the editor row in React. Deriving it from the declared name alone
// is not enough: a user can rename a seeded row — which keeps its id — and then
// pick an action declaring that same name again, so the plain id has to be
// checked against the ids already in play. parseMetadata ignores it, so it
// never ships.
function freeRowId(key, taken) {
  const base = `declared-${key}`;
  if (!taken.has(base)) return base;

  let suffix = 2;
  while (taken.has(`${base}-${suffix}`)) suffix += 1;
  return `${base}-${suffix}`;
}

export function seedDeclaredMetadata(rows, metadataSchema) {
  const declared = declaredMetadataProperties(metadataSchema);
  if (declared.length === 0) return rows;

  const seeded = [...rows];
  const takenIds = new Set(rows.map((row) => row.rowId).filter(Boolean));

  declared.forEach(({ key, defaultValue }) => {
    if (!seeded.some((row) => row.key === key)) {
      const rowId = freeRowId(key, takenIds);
      takenIds.add(rowId);
      seeded.push({ key, value: defaultValue, rowId });
    }
  });
  return seeded;
}
